// Research-Driven Formulations Section JS
// Handles tab switching, ingredient sliders, and product displays

document.addEventListener('DOMContentLoaded', function() {
  // Initialize variables
  const tabItems = document.querySelectorAll('.research-formulations-section .tab-item');
  const dynamicTabContents = document.querySelectorAll('.dynamic-tab-content');
  const ingredientShowcases = document.querySelectorAll('.ingredient-showcase');
  const productDisplays = document.querySelectorAll('.product-display');
  const selectSelected = document.querySelector('.research-formulations-section .select-selected');
  const selectItems = document.querySelector('.research-formulations-section .select-items');
  
  // Add click event to tab items
  tabItems.forEach(tab => {
    tab.addEventListener('click', function() {
      const category = this.getAttribute('data-category');
      switchToCategory(category);
      
      // Sync mobile dropdown
      if (selectSelected) {
        selectSelected.textContent = this.querySelector('span').textContent;
        selectSelected.dataset.category = category;
      }
    });
  });

  // Custom dropdown functionality
  if (selectSelected && selectItems) {
    // Toggle dropdown on click
    selectSelected.addEventListener('click', function(e) {
      e.stopPropagation();
      closeAllSelect(this);
      selectItems.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
    });
    
    // Handle option selection
    const selectOptions = selectItems.querySelectorAll('div');
    selectOptions.forEach(option => {
      option.addEventListener('click', function() {
        const category = this.dataset.category;
        const categoryText = this.textContent;
        
        // Update selected display
        selectSelected.textContent = categoryText;
        selectSelected.dataset.category = category;
        
        // Switch category
        switchToCategory(category);
        
        // Close dropdown
        selectItems.classList.add('select-hide');
        selectSelected.classList.remove('select-arrow-active');
        
        // Smooth scroll to content on mobile
        const activeContent = document.getElementById(`${category}-content`);
        if (activeContent) {
          setTimeout(() => {
            activeContent.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start' 
            });
          }, 100);
        }
        
        // Analytics tracking for mobile dropdown
        if (typeof gtag !== 'undefined') {
          gtag('event', 'mobile_dropdown_change', {
            'event_category': 'research_formulations',
            'event_label': categoryText,
            'value': category
          });
        }
      });
    });
  }
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function() {
    closeAllSelect();
  });

  /**
   * Switch to a specific category
   * @param {string} category - The category to switch to
   */
  function switchToCategory(category) {
    // Update active tab
    tabItems.forEach(item => {
      item.classList.remove('active');
      if (item.getAttribute('data-category') === category) {
        item.classList.add('active');
      }
    });
    
    // Update active tab content (heading and description)
    dynamicTabContents.forEach(content => {
      content.classList.remove('active');
      if (content.id === `${category}-content`) {
        content.classList.add('active');
      }
    });
    
    // Update active ingredient showcase
    ingredientShowcases.forEach(showcase => {
      showcase.classList.remove('active');
      if (showcase.getAttribute('data-category') === category) {
        showcase.classList.add('active');
        
        // Ensure first slide is active when switching tabs
        const slides = showcase.querySelectorAll('.ingredient-slide');
        const thumbnails = showcase.querySelectorAll('.thumbnail-item');
        
        // Reset all slides and activate first one
        slides.forEach(slide => slide.classList.remove('active'));
        thumbnails.forEach(thumb => thumb.classList.remove('active'));
        
        if (slides.length > 0) slides[0].classList.add('active');
        if (thumbnails.length > 0) thumbnails[0].classList.add('active');
      }
    });
    
    // Update active product display
    productDisplays.forEach(display => {
      display.classList.remove('active');
      if (display.getAttribute('data-category') === category) {
        display.classList.add('active');
      }
    });
  }

  /**
   * Close all select dropdowns except the current one
   * @param {HTMLElement} elmnt - The current select element to keep open
   */
  function closeAllSelect(elmnt) {
    const selectItemsAll = document.querySelectorAll('.select-items');
    const selectSelectedAll = document.querySelectorAll('.select-selected');
    
    selectItemsAll.forEach(item => {
      if (elmnt !== item.previousElementSibling) {
        item.classList.add('select-hide');
      }
    });
    
    selectSelectedAll.forEach(selected => {
      if (elmnt !== selected) {
        selected.classList.remove('select-arrow-active');
      }
    });
  }
  
  // Initialize ingredient sliders
  initIngredientSliders();
  
  // Initialize thumbnail navigation
  initThumbnailNavigation();
  
  // Function to initialize ingredient sliders
  function initIngredientSliders() {
    const showcases = document.querySelectorAll('.ingredient-showcase');
    
    showcases.forEach(showcase => {
      const prevButton = showcase.querySelector('.prev-ingredient');
      const nextButton = showcase.querySelector('.next-ingredient');
      const slides = showcase.querySelectorAll('.ingredient-slide');
      const thumbnails = showcase.querySelectorAll('.thumbnail-item');
      
      if (!slides.length) return;
      
      // Store the current index as a data attribute on the showcase
      showcase.setAttribute('data-current-index', '0');
      
      // Function to show slide at specific index
      function showSlide(index) {
        // Handle index bounds
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        
        // Store current index on showcase element
        showcase.setAttribute('data-current-index', index);
        
        // Hide all slides and show current
        slides.forEach(slide => {
          slide.classList.remove('active');
          slide.style.display = 'none';
        });
        slides[index].classList.add('active');
        slides[index].style.display = 'flex';
        
        // Update thumbnails
        thumbnails.forEach(thumb => thumb.classList.remove('active'));
        if (thumbnails[index]) thumbnails[index].classList.add('active');
        
        // Log for debugging
        console.log(`Showing slide ${index} in ${showcase.getAttribute('data-category')}`);
      }
      
      // Add click events for navigation buttons
      if (prevButton) {
        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          const currentIndex = parseInt(showcase.getAttribute('data-current-index') || 0);
          showSlide(currentIndex - 1);
        });
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          const currentIndex = parseInt(showcase.getAttribute('data-current-index') || 0);
          showSlide(currentIndex + 1);
        });
      }
      
      // Add click events for thumbnails
      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Manually remove active class from all thumbnails
          thumbnails.forEach(thumb => thumb.classList.remove('active'));
          // Manually add active class to clicked thumbnail
          thumbnail.classList.add('active');
          
          // Show corresponding slide
          showSlide(index);
        });
      });
      
      // Initialize first slide
      showSlide(0);
    });
  }
  
  // Function to initialize thumbnail navigation
  function initThumbnailNavigation() {
    const thumbnails = document.querySelectorAll('.ingredient-thumbnails .thumbnail-item');
    
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function() {
        const showcase = this.closest('.ingredient-showcase');
        const thumbIndex = parseInt(this.getAttribute('data-index'));
        const slides = showcase.querySelectorAll('.ingredient-slide');
        
        // Update active state on thumbnails
        const siblingsThumb = Array.from(this.parentNode.children);
        siblingsThumb.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        
        // Update active state on slides
        slides.forEach(slide => slide.classList.remove('active'));
        if (slides[thumbIndex]) slides[thumbIndex].classList.add('active');
      });
    });
  }
});

